'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _validate = require('../validate');

var _validate2 = _interopRequireDefault(_validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function onReplace() {
  return (0, _validate2.default)({
    name: 'onReplace',
    realTarget: function realTarget(action) {
      return action.target;
    },
    do: function _do(action, state) {
      var payload = action.payload,
          index = action.index,
          condition = action.condition,
          target = action.target;

      var array = [].concat((0, _toConsumableArray3.default)(state[target]));
      if (condition) return array.map(function (element) {
        return condition(element) ? payload : element;
      });
      if (index) array[index] = payload;
      return [].concat((0, _toConsumableArray3.default)(array));
    }
  });
}

exports.default = onReplace;